import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/plugins/element.js'
import axios from 'axios'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Vue.config.productionTip = false

axios.defaults.baseURL = 'https://api.linkdrive.com.br/'
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common['Pragma'] = 'no-cache'
axios.defaults.headers.common['Expires'] = '0'

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('_linkdrive')
  if (token) {
    config.headers.Authorization = `${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
